export default __webpack_public_path__ + "static/app-dev-852649078f3609d2a9463eafec022049.png";